<template>
    <div id="application-container">
        <progress-bar v-if="displayProgressBar" />
        <v-app>
            <component
                :id="Boolean($store.state.merchant) ? 'merchant' : ''"
                :is="currentLayout"
                :class="layoutClassName"
            />
            <login-modal />
            <notification-modal />
            <component :is="dynamicComponent"></component>
            <component v-if="!prerenderMode" :is="privacyConsentComponent"></component>

            <v-fade-transition>
                <v-btn
                    v-if="displayScrollToTop"
                    fixed
                    bottom
                    right
                    depressed
                    color="primary"
                    class="scroll-to-top pa-1"
                    @click="scrollToTop"
                >
                    <v-icon>expand_less</v-icon>
                </v-btn>
            </v-fade-transition>
        </v-app>
    </div>
</template>

<style scoped>
.scroll-to-top {
    min-width: auto;
    border-radius: 5px;
    z-index: 5;
}
</style>

<script>
import eventsMixin from './mixins/events';
import windowMixin from './mixins/window';
import { mapState } from 'vuex';

export default {
    name: 'ApplicationContainer',
    mixins: [eventsMixin, windowMixin],
    props: {
        layoutClassName: String,
    },
    data() {
        return {
            privacyConsentComponent: null,
            displayScrollToTop: false,
        }
    },
    computed: {
        ...mapState('Layout', {
            currentLayout: state => state.currentLayout,
        }),
        ...mapState([
            'dynamicComponent',
            'displayProgressBar',
        ]),
        ...mapState('PageContent', [
            'prerenderMode'
        ]),
    },
    created() {
        if (this.$store.state.PRIVACY_MODULE && this.$store.state.PRIVACY_MODULE.privacyConsentComponent) {
            this.privacyConsentComponent = this.$store.state.PRIVACY_MODULE.privacyConsentComponent;
        }
    },
    mounted() {
        document.addEventListener('scroll', this.onScroll);
    },
    beforeDestroy() {
        document.removeEventListener('scroll', this.onScroll);
    },
    methods: {
        scrollToTop() {
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth',
            });
        },
        onScroll() {
            this.displayScrollToTop = window.scrollY !== 0;
        },
    },
};
</script>
